import React, { useEffect, useState, useRef, useCallback } from "react";
import ubuntuIcon from "../assets/images/icons/servers/Ubuntu.png";
import debianIcon from "../assets/images/icons/servers/Debian.png";
import almaIcon from "../assets/images/icons/servers/AlmaLinux.png";
import centosIcon from "../assets/images/icons/servers/CentOs.png";
import fedoraIcon from "../assets/images/icons/servers/Fedora.png";
import cloudlinuxIcon from "../assets/images/icons/servers/CloudLinux.png";
import moodleIcon from "../assets/images/icons/new-icon/moodle.png";
import aaPanelIcon from "../assets/images/icons/servers/AaPanel.png";
import cyberPanelIcon from "../assets/images/icons/servers/CyberPanel.png";
import lampIcon from "../assets/images/icons/servers/LAMP.png";
import postgresqlIcon from "../assets/images/icons/servers/PostgreSQL.png";
import chrIcon from "../assets/images/icons/servers/Mikrotik.png";
import windowsIcon from "../assets/images/icons/servers/Windows.png";
import rockyIcon from "../assets/images/icons/servers/RockyLinux.png";
import trueNasIcon from "../assets/images/icons/servers/TrueNas.png";
import virtioWinIcon from "../assets/images/icons/servers/VirtioWin.png";
import winServerIcon from "../assets/images/icons/servers/WinServer.png";
import gpartedIcon from "../assets/images/icons/servers/GParted.png";
import pfSenseIcon from "../assets/images/icons/servers/pfSense.png";
import freeBsd from "../assets/images/icons/servers/FreeBSD.png";

function ensureX(ver) {
  if (!ver || ver === "-") return "Latest";
  return ver.endsWith('.x') ? ver : ver + '.x';
}

const iconMap = {
  ubuntu: ubuntuIcon,
  debian: debianIcon,
  almalinux: almaIcon,
  centos: centosIcon,
  fedora: fedoraIcon,
  cloudlinux: cloudlinuxIcon,
  chr: chrIcon,
  windows: windowsIcon,
  rocky: rockyIcon,
  "freebsd-13.0-release-amd64-dvd1.iso": freeBsd,
  "truenas-scale-22.12.1.iso": trueNasIcon,
  "virtio-win.iso": virtioWinIcon,
  "sw_dvd9_win_server_std_core_2022__64bit_english_dc_std_mlf_x22-74290.iso": winServerIcon,
  "gparted-live-1.3.0-1-amd64.iso": gpartedIcon,
  "pfsense-ce-2.6.0-release-amd64.iso": pfSenseIcon,
  // OS dari ostemplates - mapping berdasarkan distro
  "debian-9.4-x86_64": debianIcon,
  "debian-10-x86_64": debianIcon,
  "debian-11-x86_64": debianIcon,
  "debian-12-x86_64": debianIcon,
  "debian-moodle-x86_64": debianIcon,
  "debian-8-sister3-x86_64": debianIcon,
  "debian-9.11.0-amd64-Feeder-pddikti": debianIcon,
  "ubuntu-18.04-x86_64": ubuntuIcon,
  "ubuntu-20.04-x86_64": ubuntuIcon,
  "ubuntu-22.04-x86_64": ubuntuIcon,
  "ubuntu-24.04-x86_64": ubuntuIcon,
  "centos-8-x86_64": centosIcon,
  "centos-7.9-x86_64": centosIcon,
  "centos-7.7-x86_64": centosIcon,
  "rocky-8.8-x86_64": rockyIcon,
  "rocky-9.3-x86_64": rockyIcon,
  "almalinux-8.8-x86_64": almaIcon,
  "almalinux-9.3-x86_64": almaIcon,
  "almalinux-8.9-x86_64": almaIcon,
  "almalinux-9.4-x86_64": almaIcon,
  "almalinux-8.4-cpanel-latest": almaIcon,
  "almalinux-8-latest": almaIcon,
  "fedora-34-x86_64": fedoraIcon,
  "fedora-32-x86_64": fedoraIcon,
  "windows-2019": windowsIcon,
  "windows-2022": windowsIcon,
  "windows-2019-scsi-virtio": windowsIcon,
  "chr-6.48.5": chrIcon,
  "chr-7.1.1": chrIcon,
  // tambahkan mapping lain jika perlu
};

const labelMap = {
  almalinux: "AlmaLinux",
  centos: "CentOS",
  ubuntu: "Ubuntu",
  windows: "Windows Server",
  rocky: "Rocky Linux",
  debian: "Debian",
  fedora: "Fedora",
  cloudlinux: "CloudLinux",
  chr: "Mikrotik CHR",
  others: "Mikrotik",
  "virtio-win.iso": "VirtIO Windows Driver",
  "truenas-scale-22.12.1.iso": "TrueNAS SCALE",
  "gparted-live-1.3.0-1-amd64.iso": "GParted Live",
  "pfsense-ce-2.6.0-release-amd64.iso": "pfSense CE",
  "freenas": "FreeNAS",
  "freebsd-13.0-release-amd64-dvd1.iso": "FreeBSD",
  "sw_dvd9_win_server_std_core_2022__64bit_english_dc_std_mlf_x22-74290.iso": "Windows Server",
  // tambahkan mapping lain sesuai kebutuhan
};

function prettifyIsoName(name) {
  // Jika mengandung 'Win Server' atau 'Windows Server', return 'Windows Server'
  if (/win(server)?/i.test(name) || /windows server/i.test(name)) {
    return "Windows Server";
  }
  return name
    .replace(/[-_]/g, " ")
    .replace(/\.iso$/i, "")
    .replace(/release/i, "Release")
    .replace(/dvd1/i, "DVD 1")
    .replace(/ce/i, "CE")
    .replace(/amd64/i, "64-bit")
    .replace(/x86_64/i, "64-bit")
    .replace(/([0-9]+\.[0-9]+)/, "v$1")
    .replace(/\s+/g, " ")
    .trim();
}

const DISTRO_PREFIXES = [
  "almalinux",
  "rocky",
  "cloudlinux",
  "ubuntu",
  "debian",
  "centos",
  "fedora",
  "windows",
  "chr",
];

/** Bangun kartu OS dari fieldoptions WHMCS (template Virtualizor), urutan mengikuti admin. */
function buildOsListFromWhmcsTemplates(rawOptions) {
  if (!rawOptions || !Array.isArray(rawOptions) || rawOptions.length === 0) {
    return null;
  }

  const names = rawOptions
    .map((s) => String(s).trim())
    .filter((s) => s && s.toLowerCase() !== "none");

  if (names.length === 0) {
    return null;
  }

  const orderedKeys = [];
  const map = {};

  for (const fullName of names) {
    const lower = fullName.toLowerCase();
    let matched = null;
    for (const p of DISTRO_PREFIXES) {
      if (lower === p || lower.startsWith(p + "-")) {
        matched = p;
        break;
      }
    }
    if (!matched) {
      const seg = fullName.split("-")[0];
      matched = seg ? seg.toLowerCase() : null;
    }
    if (!matched) {
      continue;
    }

    let version;
    if (matched === "windows") {
      version = fullName
        .replace(/^windows-/i, "")
        .replace(/-x86_64.*$/i, "")
        .replace(/\.img$/i, "");
    } else {
      version = fullName.slice(matched.length + 1);
      version = version.replace(/-x86_64.*$/i, "").replace(/\.img$/i, "");
    }

    if (!version) {
      continue;
    }

    const label =
      matched === "chr" ? "Mikrotik" : labelMap[matched] || prettifyIsoName(matched);
    const icon = iconMap[matched] || iconMap[fullName] || null;

    if (!map[matched]) {
      map[matched] = {
        key: matched,
        label,
        icon,
        versions: [],
        os_names: {},
        osids: {},
      };
      orderedKeys.push(matched);
    }

    const g = map[matched];
    if (!g.versions.includes(version)) {
      g.versions.push(version);
    }
    g.os_names[version] = fullName;
  }

  if (orderedKeys.length === 0) {
    return null;
  }

  return orderedKeys.map((k) => {
    const os = map[k];
    return {
      ...os,
      versions: os.versions.filter((ver) => /^\d/.test(ver)),
    };
  });
}

const DEFAULT_OS_LIST = [
  { key: "ubuntu", label: "Ubuntu", icon: ubuntuIcon, versions: ["22", "20"] },
  { key: "debian", label: "Debian", icon: debianIcon, versions: ["11", "10"] },
  { key: "almalinux", label: "AlmaLinux", icon: almaIcon, versions: ["8", "9"] },
  { key: "centos", label: "CentOS", icon: centosIcon, versions: ["7"] },
  { key: "fedora", label: "Fedora", icon: fedoraIcon, versions: ["-"] },
  { key: "cloudlinux", label: "CloudLinux", icon: cloudlinuxIcon, versions: ["8", "9"] },
  { key: "windows", label: "Windows Server", icon: windowsIcon, versions: ["2022", "2019"] },
  { key: "chr", label: "Mikrotik", icon: chrIcon, versions: ["-"] },
];

const APP_LIST = [
  { key: "moodle", label: "Moodle", icon: moodleIcon, versions: ["4"], requiredOs: "debian-moodle-x86_64" },
  { key: "aapanel", label: "aaPanel", icon: aaPanelIcon, versions: ["6"], requiredOs: "centos-7.9-x86_64" },
  { key: "cyberpanel", label: "CyberPanel", icon: cyberPanelIcon, versions: ["2"], requiredOs: "almalinux-8.8-x86_64" },
  { key: "lamp", label: "LAMP", icon: lampIcon, versions: ["-"] },
  { key: "postgresql", label: "PostgreSQL", icon: postgresqlIcon, versions: ["14"], requiredOs: "debian-11-x86_64" },
  { key: "pddikti", label: "PDDIKTI Feeder", icon: debianIcon, versions: ["-"], requiredOs: "debian-9.11.0-amd64-Feeder-pddikti" },
  { key: "sister3", label: "SISTER3", icon: debianIcon, versions: ["-"], requiredOs: "debian-8-sister3-x86_64" },
  { key: "cpanel", label: "cPanel", icon: almaIcon, versions: ["-"], requiredOs: "almalinux-8.4-cpanel-latest" },
];

// Function parseOsData removed as it's not used

const VpsOsAppSelector = ({
  selectedType,
  setSelectedType,
  selectedOsOrApp,
  setSelectedOsOrApp,
  onOsNameChange,
  baseProdName,
  productListCache,
  addonsVPS,
  showAppCatalog = true,
  configs = {},
  isManagedVPS = false,
  whmcsOsTemplateOptions = null,
}) => {
  const [osList, setOsList] = useState(DEFAULT_OS_LIST);
  const [selectedVersion, setSelectedVersion] = useState("");
  const userSelectedVersion = useRef(false);
  const lastOsNameRef = useRef();

  // Helper function untuk mencari addon OS berdasarkan nama OS dan versi
  const findOsAddon = (osName, osVersion = null) => {
    if (!addonsVPS || !osName) return null;

    // console.log('🔍 Finding OS addon for:', { osName, osVersion, configs, availableAddons: addonsVPS });

    // Mapping OS name ke addon name yang sesuai berdasarkan data yang diberikan
    // OS Linux = GRATIS (billingcycle: "free", harga: "-1.00")
    // OS Windows/CloudLinux = BERBAYAR (billingcycle: "recurring", harga: "416000.00", dll)
    const osMapping = {
      // OS GRATIS (Linux)
      'Ubuntu': 'Operating System - Ubuntu',
      'Debian': 'Operating System - Debian',
      'AlmaLinux': 'Operating System - Almalinux',
      'CentOS': 'Operating System - CentOS',
      'Fedora': 'Operating System - Fedora',
      'Mikrotik': 'Operating System - Mikrotik',
      'FreeBSD': 'Operating System - FreeBSD',
      'FreeNAS': 'Operating System - FreeNAS',
      
      // OS BERBAYAR
      'CloudLinux': 'Operating System - CloudLinux OS',
      'Windows Server': 'Operating System - Windows Server Standard'
    };

    const targetAddonName = osMapping[osName];

    if (!targetAddonName) {
      // Jika tidak ada mapping yang tepat, coba cari berdasarkan nama yang mengandung OS name
      // Windows Server addon memiliki input_name: "Operating System"
      const fallbackAddon = addonsVPS.find(addon =>
        (addon.input_name === "Operating System" || addon.input_name === "Others") &&
        addon.name.toLowerCase().includes(osName.toLowerCase())
      );
      // console.log('🔍 Fallback addon found:', fallbackAddon);
      return fallbackAddon;
    }

    // Cari addon yang sesuai dengan nama OS
    // Windows Server addon memiliki input_name: "Operating System"
    let exactAddon = addonsVPS.find(addon =>
      (addon.input_name === "Operating System" || addon.input_name === "Others") &&
      addon.name === targetAddonName
    );

    // Jika tidak ditemukan dan ini adalah Windows Server, coba cari dengan core count
    if (!exactAddon && osName === "Windows Server") {
      // Untuk Windows Server, kita perlu mencari berdasarkan core count
      // Core count ditentukan oleh total core (base + additional) dari VPS Custom
      const totalCores = (configs.additional_cores || 2);
      // console.log('🖥️ Windows Server - Total cores:', totalCores, 'from configs:', configs);
      
      // Cari addon Windows Server yang tersedia
      const windowsAddons = addonsVPS.filter(addon =>
        (addon.input_name === "Operating System" || addon.input_name === "Others") &&
        addon.name.toLowerCase().includes("windows server")
      );
      
      if (windowsAddons.length > 0) {
        // Logika mapping berdasarkan total core
        let targetCoreCount;
        
        if (totalCores <= 4) {
          targetCoreCount = 4; // 2-4 core -> 4 core
        } else if (totalCores <= 8) {
          targetCoreCount = 8; // 6-8 core -> 8 core
        } else if (totalCores <= 16) {
          targetCoreCount = 16; // 10-16 core -> 16 core
        } else if (totalCores <= 24) {
          targetCoreCount = 24; // 18-24 core -> 24 core
        } else {
          targetCoreCount = 32; // 26+ core -> 32 core
        }
        
        // console.log('🎯 Target core count for', totalCores, 'cores:', targetCoreCount);
        
        // Cari addon yang sesuai dengan target core count
        const matchingAddon = windowsAddons.find(addon => {
          // Extract core count dari nama addon: "Windows Server Standard (4 Core)" -> 4
          const coreMatch = addon.name.match(/\((\d+)\s+Core\)/i);
          if (coreMatch) {
            const addonCoreCount = parseInt(coreMatch[1]);
            return addonCoreCount === targetCoreCount;
          }
          return false;
        });
        
        if (matchingAddon) {
          exactAddon = matchingAddon;
          // console.log('✅ Target match found:', matchingAddon.name);
        } else {
          // Jika tidak ada yang exact match, ambil yang paling dekat
          // Prioritaskan yang core count-nya lebih kecil atau sama dengan target core
          const suitableAddons = windowsAddons.filter(addon => {
            const coreMatch = addon.name.match(/\((\d+)\s+Core\)/i);
            if (coreMatch) {
              const addonCoreCount = parseInt(coreMatch[1]);
              return addonCoreCount <= targetCoreCount;
            }
            return false;
          });
          
          // console.log('🔍 Suitable addons (<=', targetCoreCount, 'cores):', suitableAddons.map(a => a.name));
          
          if (suitableAddons.length > 0) {
            // Ambil yang core count-nya terbesar tapi masih <= target core
            exactAddon = suitableAddons.sort((a, b) => {
              const aCore = parseInt(a.name.match(/\((\d+)\s+Core\)/i)?.[1] || '0');
              const bCore = parseInt(b.name.match(/\((\d+)\s+Core\)/i)?.[1] || '0');
              return bCore - aCore;
            })[0];
            // console.log('✅ Fallback selected:', exactAddon.name);
          } else {
            // Fallback: ambil yang pertama
            exactAddon = windowsAddons[0];
            // console.log('⚠️ No suitable addons, using first available:', exactAddon.name);
          }
        }
      }
    }
    
    // console.log('🔍 Exact addon found:', exactAddon);
    
    // Log informasi pricing untuk debugging
    // if (exactAddon) {
    //   console.log('💰 OS Pricing Info:', {
    //     name: exactAddon.name,
    //     billingcycle: exactAddon.billingcycle,
    //     monthly: exactAddon.monthly,
    //     isFree: exactAddon.billingcycle === 'free' || exactAddon.monthly === '-1.00'
    //   });
    // }
    
    return exactAddon;
  };

  // Helper function getOsPrice removed as it's not used

  useEffect(() => {
    const fromWhmcs =
      whmcsOsTemplateOptions &&
      Array.isArray(whmcsOsTemplateOptions) &&
      whmcsOsTemplateOptions.length > 0
        ? buildOsListFromWhmcsTemplates(whmcsOsTemplateOptions)
        : null;

    if (fromWhmcs && fromWhmcs.length > 0) {
      setOsList((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(fromWhmcs)) {
          return fromWhmcs;
        }
        return prev;
      });
      return;
    }

    // Hardcode data OS templates (fallback jika produk tidak punya daftar di custom field)
    const hardcodedOstemplates = [
      {
        "osid": "771",
        "type": "kvm",
        "name": "debian-9.4-x86_64",
        "filename": "debian-9.4-x86_64.img",
        "size": "1396703232",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=771",
        "distro": "debian",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3", "5"]
      },
      {
        "osid": "812",
        "type": "kvm",
        "name": "ubuntu-18.04-x86_64",
        "filename": "ubuntu-18.04-x86_64.img",
        "size": "1732247552",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=812",
        "distro": "ubuntu",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3"]
      },
      {
        "osid": "878",
        "type": "kvm",
        "name": "debian-10-x86_64",
        "filename": "debian-10-x86_64.img",
        "size": "2738897408",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=878",
        "distro": "debian",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3"]
      },
      {
        "osid": "895",
        "type": "kvm",
        "name": "centos-8-x86_64",
        "filename": "centos-8-x86_64.img",
        "size": "2042626048",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=895",
        "distro": "centos",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3", "5"]
      },
      {
        "osid": "909",
        "type": "kvm",
        "name": "ubuntu-20.04-x86_64",
        "filename": "ubuntu-20.04-x86_64.img",
        "size": "2311061504",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=909",
        "distro": "ubuntu",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3"]
      },
      {
        "osid": "961",
        "type": "kvm",
        "name": "centos-7.9-x86_64",
        "filename": "centos-7.9-x86_64.img",
        "size": "2856353792",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=961",
        "distro": "centos",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3", "5"]
      },
      {
        "osid": "979",
        "type": "kvm",
        "name": "debian-11-x86_64",
        "filename": "debian-11-x86_64.img",
        "size": "2793406464",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=979",
        "distro": "debian",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3"]
      },
      {
        "osid": "995",
        "type": "kvm",
        "name": "fedora-34-x86_64",
        "filename": "fedora-34-x86_64.img",
        "size": "2805989376",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=995",
        "distro": "fedora",
        "Nvirt": "kvm"
      },
      {
        "osid": "1017",
        "type": "kvm",
        "name": "ubuntu-22.04-x86_64",
        "filename": "ubuntu-22.04-x86_64.img",
        "size": "4114612224",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1017",
        "distro": "ubuntu",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3"]
      },
      {
        "osid": "1055",
        "type": "kvm",
        "name": "debian-12-x86_64",
        "filename": "debian-12-x86_64.qcow2",
        "size": "561552384",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1055",
        "distro": "debian",
        "Nvirt": "kvm"
      },
      {
        "osid": "1060",
        "type": "kvm",
        "name": "rocky-8.8-x86_64",
        "filename": "rocky-8.8-x86_64.img",
        "size": "3992977408",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1060",
        "distro": "rocky",
        "Nvirt": "kvm"
      },
      {
        "osid": "1063",
        "type": "kvm",
        "name": "almalinux-8.8-x86_64",
        "filename": "almalinux-8.8-x86_64.img",
        "size": "3879731200",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1063",
        "distro": "almalinux",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3"]
      },
      {
        "osid": "1072",
        "type": "kvm",
        "name": "rocky-9.3-x86_64",
        "filename": "rocky-9.3-x86_64.img",
        "size": "2793406464",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1072",
        "distro": "rocky",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3", "5"]
      },
      {
        "osid": "1075",
        "type": "kvm",
        "name": "almalinux-9.3-x86_64",
        "filename": "almalinux-9.3-x86_64.img",
        "size": "2587885568",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1075",
        "distro": "almalinux",
        "Nvirt": "kvm"
      },
      {
        "osid": "1081",
        "type": "kvm",
        "name": "almalinux-8.9-x86_64",
        "filename": "almalinux-8.9-x86_64.img",
        "size": "4005560320",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1081",
        "distro": "almalinux",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3", "5"]
      },
      {
        "osid": "1108",
        "type": "kvm",
        "name": "ubuntu-24.04-x86_64",
        "filename": "ubuntu-24.04-x86_64.img",
        "size": "2793406464",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1108",
        "distro": "ubuntu",
        "Nvirt": "kvm"
      },
      {
        "osid": "1113",
        "type": "kvm",
        "name": "almalinux-9.4-x86_64",
        "filename": "almalinux-9.4-x86_64.img",
        "size": "2621440000",
        "pygrub": "0",
        "drive": [],
        "hvm": "0",
        "perf_ops": "1",
        "active": "1",
        "url": "http://files.virtualizor.com/ostemplates.php?osid=1113",
        "distro": "almalinux",
        "Nvirt": "kvm",
        "mg": ["1", "2", "3"]
      },
      {
        "type": "kvm",
        "filename": "debian-moodle-x86_64.img",
        "name": "debian-moodle-x86_64",
        "url": [],
        "size": "5368709120",
        "fstype": "ext3",
        "perf_ops": "1",
        "distro": "debian",
        "Nvirt": "kvm"
      },
      {
        "type": "kvm",
        "url": [],
        "filename": "windows-2019.img",
        "name": "windows-2019",
        "fstype": "ext3",
        "perf_ops": "1",
        "size": "16106127360",
        "distro": "windows",
        "mg": "1",
        "Nvirt": "kvm"
      },
      {
        "type": "kvm",
        "url": [],
        "filename": "chr-6.48.5.img",
        "name": "chr-6.48.5",
        "fstype": "ext3",
        "size": "3221225472",
        "distro": "others",
        "mg": ["1", "3"],
        "Nvirt": "kvm"
      },
      {
        "type": "kvm",
        "url": [],
        "filename": "almalinux-8.4-cpanel-latest.img",
        "name": "almalinux-8.4-cpanel-latest",
        "fstype": "ext3",
        "perf_ops": "1",
        "size": "11811160064",
        "distro": "almalinux",
        "mg": "1",
        "Nvirt": "kvm"
      },
      {
        "type": "kvm",
        "filename": "debian-8-sister3-x86_64.img",
        "name": "debian-8-sister3-x86_64",
        "url": [],
        "size": "5368709120",
        "fstype": "ext3",
        "perf_ops": "1",
        "distro": "debian",
        "Nvirt": "kvm"
      },
      {
        "type": "kvm",
        "url": [],
        "filename": "chr-7.1.1.img",
        "name": "chr-7.1.1",
        "fstype": "ext3",
        "size": "3221225472",
        "distro": "others",
        "mg": ["1", "3"],
        "Nvirt": "kvm"
      },
      {
        "type": "kvm",
        "filename": "debian-9.11.0-amd64-Feeder-pddikti.img",
        "name": "debian-9.11.0-amd64-Feeder-pddikti",
        "url": [],
        "size": "5368709120",
        "fstype": "ext3",
        "perf_ops": "1",
        "distro": "debian",
        "Nvirt": "kvm"
      },
      {
        "type": "kvm",
        "url": [],
        "filename": "windows-2022.img",
        "name": "windows-2022",
        "fstype": "ext3",
        "perf_ops": "1",
        "size": "18270388224",
        "distro": "windows",
        "mg": "1",
        "Nvirt": "kvm"
      },
      {
        "type": "kvm",
        "fstype": "ext3",
        "perf_ops": "1",
        "url": [],
        "filename": "windows-2019-scsi-virtio.img",
        "name": "windows-2019-scsi-virtio",
        "size": "21491613696",
        "distro": "windows",
        "Nvirt": "kvm"
      }
    ];



    // Transform ke format osList
    const osMap = {};

    hardcodedOstemplates.forEach(template => {
      const distro = template.distro || 'mikrotik';
      const name = template.name || '';

      // Extract version dari name dengan pattern yang lebih fleksibel
      let version = '';
      if (name) {
        // Pattern untuk berbagai format versi: 9.4, 18.04, 8.6x, 8.11x, 9.11.0, dll
        const versionMatch = name.match(/([0-9]+(?:\.[0-9]+(?:[xX]|\.[0-9]+)?)?)/);
        if (versionMatch) {
          version = versionMatch[1];
        }

        // Handle kasus khusus seperti "moodle", "sister3", "Feeder-pddikti"
        if (name.includes('moodle')) {
          version = 'moodle';
        } else if (name.includes('sister3')) {
          version = 'sister3';
        } else if (name.includes('Feeder-pddikti')) {
          version = 'feeder-pddikti';
        } else if (name.includes('cpanel-latest')) {
          version = 'cpanel-latest';
        } else if (name.includes('latest')) {
          version = 'latest';
        } else if (name.includes('scsi-virtio')) {
          version = 'scsi-virtio';
        }
      }

      if (!osMap[distro]) {
        const key = distro.toLowerCase().replace(/\s+/g, "");
        // Gunakan labelMap berdasarkan distro saja, bukan template name
        const label = labelMap[distro] || prettifyIsoName(distro) || distro;
        // Gunakan iconMap berdasarkan distro atau template name sebagai fallback
        const icon = iconMap[distro] || iconMap[name] || iconMap[key] || null;
        osMap[distro] = {
          key,
          label,
          icon,
          versions: [],
          os_names: {},
          osids: {} // Tambahkan mapping osid
        };
      }

      if (version && !osMap[distro].versions.includes(version)) {
        osMap[distro].versions.push(version);
      }

      if (template.osid && version) {
        osMap[distro].osids[version] = template.osid;
      }

      if (name) {
        osMap[distro].os_names[version] = name;
      }
    });

    const parsed = Object.values(osMap).map(os => ({
      ...os,
      versions: os.versions.sort((a, b) => {
        // Handle versi khusus (non-numerik) - taruh di akhir
        const aIsSpecial = !/^\d/.test(a);
        const bIsSpecial = !/^\d/.test(b);

        if (aIsSpecial && !bIsSpecial) return 1;
        if (!aIsSpecial && bIsSpecial) return -1;
        if (aIsSpecial && bIsSpecial) return a.localeCompare(b);

        // Sort versi numerik secara descending (terbaru di atas)
        const numA = parseFloat(a);
        const numB = parseFloat(b);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numB - numA; // Descending order
        }

        // Fallback untuk versi campuran
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
      }).filter(version => {
        // Sembunyikan versi non-numerik dari list OS (hanya tampilkan di App Catalog)
        return /^\d/.test(version);
      })
    }));

    // Tambahkan CloudLinux secara manual jika tidak ada dalam data API
    let finalOsList = [...parsed];
    const cloudlinuxExists = finalOsList.some(os => os.key === 'cloudlinux');

    if (!cloudlinuxExists) {
      const cloudlinuxEntry = {
        key: 'cloudlinux',
        label: 'CloudLinux',
        icon: cloudlinuxIcon,
        versions: ['8', '9'],
        os_names: {
          '8': 'cloudlinux-8-x86_64',
          '9': 'cloudlinux-9-x86_64'
        },
        osids: {}
      };
      finalOsList.push(cloudlinuxEntry);
    }

    if (finalOsList && finalOsList.length > 0) {
      setOsList(prev => {
        if (JSON.stringify(prev) !== JSON.stringify(finalOsList)) {
          return finalOsList;
        }
        return prev;
      });
    } else {
      setOsList(DEFAULT_OS_LIST);
    }
  }, [whmcsOsTemplateOptions]);

  // Helper function untuk cek ketersediaan Windows Server addon
  const isWindowsServerAvailable = useCallback(() => {
    if (!addonsVPS || addonsVPS.length === 0) return false;
    
    return addonsVPS.some(addon =>
      (addon.input_name === "Operating System" || addon.input_name === "Others") &&
      addon.name.toLowerCase().includes("windows server")
    );
  }, [addonsVPS]);

  // useEffect untuk menangani perubahan ketersediaan Windows Server addon
  useEffect(() => {
    if (selectedType === "os" && selectedOsOrApp === "windows" && !isWindowsServerAvailable()) {
      // Jika Windows Server dipilih tapi addon tidak tersedia, reset ke OS pertama yang tersedia
      const firstAvailableOs = osList.find(os => os.key !== "windows");
      
      if (firstAvailableOs) {
        setSelectedOsOrApp(firstAvailableOs.key);
        setSelectedVersion(ensureX(firstAvailableOs.versions[0]));
        userSelectedVersion.current = false;
      }
    }
  }, [addonsVPS, selectedOsOrApp, selectedType, osList, isWindowsServerAvailable, setSelectedOsOrApp]);

  // Batas WHMCS: pastikan pilihan OS valid (termasuk setelah ganti pid)
  useEffect(() => {
    if (isManagedVPS) return;
    if (!whmcsOsTemplateOptions || whmcsOsTemplateOptions.length === 0) return;
    if (selectedType !== "os") return;
    if (!osList || osList.length === 0) return;

    const validKeys = osList.map((o) => o.key);
    const windowsOk = isWindowsServerAvailable();
    const currentValid =
      validKeys.includes(selectedOsOrApp) &&
      (selectedOsOrApp !== "windows" || windowsOk);

    if (selectedOsOrApp !== "choose" && currentValid) return;

    const first =
      osList.find((o) => o.key !== "windows" || windowsOk) || osList[0];
    if (!first?.versions?.length) return;

    setSelectedOsOrApp(first.key);
    setSelectedVersion(ensureX(first.versions[0]));
    userSelectedVersion.current = false;
  }, [
    osList,
    whmcsOsTemplateOptions,
    selectedOsOrApp,
    selectedType,
    isManagedVPS,
    isWindowsServerAvailable,
    setSelectedOsOrApp,
  ]);

  // Helper function untuk cek ketersediaan aplikasi untuk produk tertentu
  const isAppAvailable = (appLabel, baseProdName) => {
    if (!productListCache || !baseProdName) return true; // Default true jika data belum ada

    let pattern = "";
    switch (appLabel) {
      case "LEMP":
        pattern = `${baseProdName} DEBIAN 11 LEMP`;
        break;
      case "Moodle":
        pattern = `${baseProdName} Moodle`;
        break;
      case "aaPanel":
        pattern = `${baseProdName} Centos 7 + aaPanel`;
        break;
      case "CyberPanel":
        pattern = `${baseProdName} + Almalinux 8 CyberPanel`;
        break;
      case "PostgreSQL":
        pattern = `${baseProdName} + Postgre 14`;
        break;
      case "LAMP":
        pattern = `${baseProdName} + LAMP`;
        break;
      case "SISTER3":
        pattern = `${baseProdName} + Debian 8 Sister Risetdikti`;
        break;
      case "PDDIKTI Feeder":
        pattern = `${baseProdName} + PDDIKTI Feeder`;
        break;
      case "cPanel":
        pattern = `${baseProdName} + cPanel`;
        break;
      default:
        pattern = `${baseProdName} + ${appLabel}`;
    }

    return productListCache.some(prod => prod.name === pattern || prod.name.includes(pattern));
  };

  // Filter APP_LIST berdasarkan ketersediaan
  const availableAppList = APP_LIST.filter(app => isAppAvailable(app.label, baseProdName));

  // Gabungkan reset flag dan set default version
  useEffect(() => {
    // Untuk Managed VPS, force select CloudLinux
    if (isManagedVPS && selectedType === "os" && selectedOsOrApp !== "cloudlinux") {
      setSelectedOsOrApp("cloudlinux");
      const cloudlinuxOs = osList.find(os => os.key === "cloudlinux");
      if (cloudlinuxOs && cloudlinuxOs.versions.length > 0) {
        const defaultVersion = ensureX(cloudlinuxOs.versions[0]);
        setSelectedVersion(defaultVersion);
      }
      return;
    }
    
    // Hanya reset flag jika OS/App berubah, bukan jika hanya versi yang berubah
    if (selectedOsOrApp !== lastOsNameRef.current) {
      userSelectedVersion.current = false;
      lastOsNameRef.current = selectedOsOrApp;
    }
    
    const list = selectedType === "os" ? osList : availableAppList;
    const found = list.find(item => item.key === selectedOsOrApp);
    
    // Hanya set default version jika:
    // 1. User belum memilih versi secara manual, DAN
    // 2. Versi saat ini tidak tersedia di daftar versi
    if (
      found &&
      found.versions.length > 0 &&
      !userSelectedVersion.current &&
      (!selectedVersion || !found.versions.map(ensureX).includes(ensureX(selectedVersion)))
    ) {
      const newVersion = ensureX(found.versions[0]);
      if (selectedVersion !== newVersion) {
        setSelectedVersion(newVersion);
      }
    }
    // eslint-disable-next-line
  }, [selectedOsOrApp, selectedType, osList, isManagedVPS]);

  // Kirim os_name ke parent setiap kali OS/versi berubah, hanya jika value berubah
  useEffect(() => {
    let payload;
    if (selectedType === "os") {
      const found = osList.find(item => item.key === selectedOsOrApp);

      if (found && found.os_names) {
        // Gunakan selectedVersion jika ada, atau versi pertama yang tersedia
        const versionToUse = selectedVersion || (found.versions.length > 0 ? ensureX(found.versions[0]) : null);
        
        if (versionToUse) {
          // Debug: log untuk troubleshooting
          // console.log('🔍 Version matching debug:', {
          //   selectedVersion,
          //   versionToUse,
          //   availableVersions: Object.keys(found.os_names),
          //   availableVersionsWithX: Object.keys(found.os_names).map(v => ensureX(v))
          // });
          
          const verKey = Object.keys(found.os_names).find(v => ensureX(v) === versionToUse);

          if (verKey) {
            const osName = found.os_names[verKey];
            const osid = found.osids && found.osids[verKey] ? found.osids[verKey] : null;

            // Cari addon yang sesuai dengan OS yang dipilih
            const osAddon = findOsAddon(found.label, versionToUse);

            payload = {
              osName: osName,
              osid: osid,
              appInfo: undefined,
              osAddon: osAddon // Tambahkan informasi addon
            };
          } else {
            // Fallback: coba cari dengan versi yang lebih fleksibel
            // console.log('🔍 Version not found, trying fallback matching');
            const fallbackVerKey = Object.keys(found.os_names).find(v => {
              const normalizedV = ensureX(v);
              const normalizedSelected = ensureX(selectedVersion);
              return normalizedV === normalizedSelected || 
                     normalizedV.includes(selectedVersion) || 
                     selectedVersion.includes(v);
            });
            
            if (fallbackVerKey) {
              const osName = found.os_names[fallbackVerKey];
              const osid = found.osids && found.osids[fallbackVerKey] ? found.osids[fallbackVerKey] : null;
              const osAddon = findOsAddon(found.label, versionToUse);

              payload = {
                osName: osName,
                osid: osid,
                appInfo: undefined,
                osAddon: osAddon
              };
            }
          }
        }
      }
    } else if (selectedType === "app") {
      const foundApp = availableAppList.find(item => item.key === selectedOsOrApp);
      if (foundApp) {
        payload = {
          osName: foundApp.requiredOs || "",
          osid: null,
          appInfo: {
            app: selectedOsOrApp,
            appLabel: foundApp.label,
            requiredOs: foundApp.requiredOs,
            version: selectedVersion
          },
          osAddon: null
        };
      }
    }

    if (payload && JSON.stringify(payload) !== JSON.stringify(lastOsNameRef.current)) {
      lastOsNameRef.current = payload;
      if (typeof onOsNameChange === "function") {
        if (selectedType === "os") {
          onOsNameChange(payload.osName, payload.osid, null, payload.osAddon);
        } else if (selectedType === "app") {
          onOsNameChange(payload.osName, payload.osid, payload.appInfo);
        }
      }
    }
    // eslint-disable-next-line
  }, [selectedOsOrApp, selectedVersion, selectedType, addonsVPS, configs]);

  const handleSelect = (key, versions) => {
    // Untuk Managed VPS, prevent change dari CloudLinux
    if (isManagedVPS && selectedType === "os" && key !== "cloudlinux") {
      return; // Block selection
    }
    
    setSelectedOsOrApp(key);
    
    // Hanya set versi default jika OS/App berubah (bukan jika user sedang memilih versi)
    if (selectedOsOrApp !== key) {
      if (selectedType === "os") {
        const found = osList.find(item => item.key === key);
        if (found && found.versions.length > 0) {
          const defaultVersion = ensureX(found.versions[0]);
          setSelectedVersion(defaultVersion);
          userSelectedVersion.current = false; // Reset flag saat OS berubah
        }
      } else if (selectedType === "app") {
        const foundApp = availableAppList.find(item => item.key === key);
        if (foundApp && foundApp.versions.length > 0) {
          const defaultVersion = ensureX(foundApp.versions[0]);
          setSelectedVersion(defaultVersion);
          userSelectedVersion.current = false; // Reset flag saat App berubah
        }
      }
    }
  };

  // Handler untuk select versi
  const handleVersionChange = (e) => {
    userSelectedVersion.current = true;
    setSelectedVersion(e.target.value);
  };

  // Helper untuk ambil versi dari requiredOs
  function getAppCatalogVersion(appItem) {
    if (!appItem || !appItem.requiredOs) return ["Latest"];
    // Ekstrak versi numerik dari requiredOs
    const match = appItem.requiredOs.match(/([0-9]+(?:\.[0-9]+)?)/);
    if (match) {
      return [ensureX(match[1])];
    }
    return ["Latest"];
  }

  const renderCard = (item, selectedKey, setSelectedKey) => {
    const isSelected = selectedKey === item.key;
    let isAvailable = true;
    
    if (selectedType === "app") {
      isAvailable = isAppAvailable(item.label, baseProdName);
    } else if (selectedType === "os") {
      // Untuk Windows Server, cek ketersediaan addon
      if (item.key === "windows") {
        isAvailable = isWindowsServerAvailable();
      }
    }
    let versions = item.versions.map(ensureX);
    // Untuk App Catalog, override versi dengan versi dari requiredOs
    if (selectedType === "app" && item.requiredOs) {
      versions = getAppCatalogVersion(item);
    }
    return (
      <div className="col text-center" key={item.key}>
        <div className={`card h-100 border vps-os-card ${isSelected ? "border-primary vps-os-selected" : ""} ${!isAvailable ? "bg-light" : ""}`}
          style={{ minHeight: 150, cursor: isAvailable ? "pointer" : "not-allowed", opacity: isAvailable ? 1 : 0.6 }}
          onClick={() => isAvailable && handleSelect(item.key, item.versions)}
        >
          <div className="card-body p-2 d-flex flex-column align-items-center justify-content-center vps-os-card-body">
            <input
              type="radio"
              name={selectedType === "os" ? "osRadio" : "appRadio"}
              checked={isSelected}
              onChange={() => handleSelect(item.key, item.versions)}
              className="form-check-input mb-2"
              style={{ position: "absolute", left: 10, top: 10 }}
              tabIndex={-1}
              disabled={!isAvailable}
            />
            {item.icon ? (
              <img src={item.icon} alt={item.label} style={{ height: 40, marginBottom: 8 }} />
            ) : (
              <div className="vps-os-no-icon" style={{ height: 40, marginBottom: 8, background: "#eee", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", width: 40 }}>No Icon</div>
            )}
            <div className="fw-bold vps-os-label">{item.label}</div>
            {!isAvailable && (
              <small className="text-muted vps-os-unavailable">
                {selectedType === "os" && item.key === "windows" 
                  ? "Addon tidak tersedia" 
                  : "Tidak tersedia"}
              </small>
            )}
            <select
              className="form-select mt-2 vps-os-select"
              value={isSelected ? selectedVersion : ""}
              onChange={handleVersionChange}
              disabled={!isSelected || !isAvailable}
            >
              <option value="" disabled>Version</option>
              {versions.map(ver => (
                <option value={ver} key={ver}>{ver}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="mb-3">
      {!isManagedVPS && (
      <div className="d-flex mb-3">
        <button
          type="button"
          className={`btn me-2 vps-type-toggle-btn ${selectedType === "os"
            ? "btn-qw-primary text-white vps-type-toggle-active"
            : "btn-outline-qw-primary text-qw-primary border-qw-primary vps-type-toggle-inactive"}`}
          style={{
            borderRadius: '50px',
            fontWeight: 'bold',
            padding: '8px 20px'
          }}
          onClick={() => setSelectedType("os")}
        >
          Virtual Machine
        </button>
        {showAppCatalog && (
          <button
            type="button"
            className={`btn vps-type-toggle-btn ${selectedType === "app"
              ? "btn-qw-primary text-white vps-type-toggle-active"
              : "btn-outline-qw-primary text-qw-primary border-qw-primary vps-type-toggle-inactive"}`}
            style={{
              borderRadius: '50px',
              fontWeight: 'bold',
              padding: '8px 20px'
            }}
            onClick={() => setSelectedType("app")}
          >
            App Catalog
          </button>
        )}
      </div>
      )}
      {selectedType === "os" && (
        <>
          <label className="fw-bold mb-2 vps-os-section-label">OS*</label>
          {isManagedVPS ? (
            // Untuk Managed VPS, tampilkan dropdown yang terkunci ke CloudLinux
            (() => {
              const cloudlinuxOs = osList.find(os => os.key === "cloudlinux");
              if (!cloudlinuxOs) return null;
              
              return (
                <div className="mb-4">
                  <select
                    className="form-select"
                    value="cloudlinux"
                    disabled={true}
                    style={{ cursor: "not-allowed", opacity: 0.7 }}
                  >
                    <option value="cloudlinux">CloudLinux</option>
                  </select>
                  {cloudlinuxOs.versions.length > 0 && (
                    <select
                      className="form-select mt-2"
                      value={selectedVersion || (cloudlinuxOs.versions.length > 0 ? ensureX(cloudlinuxOs.versions[0]) : "")}
                      onChange={handleVersionChange}
                    >
                      <option value="" disabled>Pilih Versi</option>
                      {cloudlinuxOs.versions.map(ver => (
                        <option value={ensureX(ver)} key={ver}>{ensureX(ver)}</option>
                      ))}
                    </select>
                  )}
                </div>
              );
            })()
          ) : (
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mb-2">
            {osList.map(os => renderCard(os, selectedOsOrApp, setSelectedOsOrApp))}
          </div>
          )}
        </>
      )}
      {selectedType === "app" && showAppCatalog && (
        <>
          <label className="fw-bold mb-2">Aplikasi*</label>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mb-2">
            {availableAppList.map(app => renderCard(app, selectedOsOrApp, setSelectedOsOrApp))}
          </div>
          {availableAppList.length === 0 && (
            <div className="text-center text-muted py-3">
              <small>Tidak ada aplikasi yang tersedia untuk produk {baseProdName}</small>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default VpsOsAppSelector; 